export * from './ccf-common-call-icons.map';
export * from './ccf-conference-call-icons.map';
export * from './ccf-conference-hold-icon.map';